<template>
  <IconLucideGripVertical />
</template>
